import React, {useEffect} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import Misc from "../../../misc/misc";
import {changeUserInfo, changeUserInfoErrors} from "../../../actions/actionFunctions";
import {useIsMounted} from "../../../misc/helperHooks";
import UserFieldErrors from "../userPopup/userFieldsErrors";

const AssignQuotePopupNewCustomerInput = (props) => {

  const {property, userInfo, changeUserInfo, intl, placeholder, userInfoErrors, changeUserInfoErrors,
    inputsValidated, isActive, fabricatorData, assignQuotePopupSaveButtons, tabIndex} = props;
  const isMounted = useIsMounted();

  const inputValue = userInfo[property];

  const onBlur = () => {
    const errors = Misc.getValidationErrors(inputValue, property, fabricatorData);
    if (errors.length) {
      changeUserInfoErrors({
        [property]: errors
      })
    } else if (!errors.length && userInfoErrors[property]) {
      changeUserInfoErrors({
        [property]: errors
      })
    }
  };

  useEffect(() => {
    if (isMounted() && isActive) {
      // console.log("inputsValidated", inputsValidated);
      onBlur({
        target: {
          value: inputValue
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsValidated]);

  const onChange = (event) => {
    changeUserInfo({
      [property]: event.target.value
    });
    if (userInfoErrors[property]) {
      const errors = Misc.getValidationErrors(event.target.value, property, fabricatorData);
      if (!errors.length) {
        changeUserInfoErrors({
          [property]: errors
        })
      }
    }
  };

  const errorsExist = Array.isArray(userInfoErrors[property]) && userInfoErrors[property].length;

  const requiredFields = fabricatorData.isCaesarStone
    ? ["lastName", "city", "state"]
    : ["firstName", "email", "postal", "phoneNumber"];

  return (
    <div className="ass-field">
      <input type="text"
             name={property}
             tabIndex={tabIndex}
             className={"ui-input ui-input--new ass-field__input" + (errorsExist ? " ui-input--error" : "")}
             onChange={onChange}
             onBlur={onBlur}
             placeholder={intl.formatMessage({id: placeholder})}
             value={inputValue}
      />
      {requiredFields.includes(property) ? <span className="ass-field__required">*</span> : null}
      {((property === "postal")
        && fabricatorData.settings.sureTax
        && !inputValue
        && (assignQuotePopupSaveButtons === "updateTax")
        && (!Array.isArray(userInfoErrors[property]) || !userInfoErrors[property].length)) ? (
        <div className="ass-field__errors">
          <span className="ass-field__errors-error">
            <FormattedMessage id={"assignPopup.errors.updateZip"}/>
          </span>
        </div>
      ) : <UserFieldErrors property={property}/>}
    </div>
  )
};

AssignQuotePopupNewCustomerInput.propTypes = {
  property: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  inputsValidated: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  tabIndex: PropTypes.number,
};

const mapStateToProps = (store) => {
  const {userInfo, userInfoErrors} = store.userState;
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;
  return {
    userInfo,
    userInfoErrors,
    fabricatorData: store.fabricatorState,
    assignQuotePopupSaveButtons,
    // assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText
  };
};

const mapDispatchToProps = {
  changeUserInfo,
  changeUserInfoErrors
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupNewCustomerInput)
)
